module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAACXBIWXMAAAsSAAALEgHS3X78AAAAX0lEQVRYhe3ZoRGAUBDE0IWhmOu/mb/lMEhU7ImkgudznXOyqSfJzCwRtb0XMH4JogRRgihBlCBKECWIEkQJogRRgihBlCBKECWIEkQJogRRgihBlCBKEPXdoLZLNElewX0IceLZuwwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/checkbox.png
// module id = 1746
// module chunks = 0